<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Commission Plan</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Commission Plan</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="CommissionPlan">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'CommissionPlanList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      v-bind:class="{ 'has-error': errors.has('name') }"
                      v-validate="'required'"
                      v-model="value.name"
                      class="form-control name"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Description</label>
                    <input
                      type="text"
                      id="description"
                      name="description"
                      v-model="value.description"
                      class="form-control description"
                      placeholder="Description"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('description')"
                    >
                      {{ errors.first("description") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Status</label>
                    <input
                      type="text"
                      id="status"
                      name="status"
                      v-model="value.status"
                      class="form-control status"
                      placeholder="Status"
                    />
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">App-Id</label>
                    <select
                      id="categories"
                      v-model="value.app_id"
                      class="form-control"
                    >
                      <option
                        v-for="application in allApplications"
                        :value="application.app_id"
                        :key="application.app_id"
                      >
                        {{ application.name }}
                      </option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('app_id')">
                      {{ errors.first("app_id") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CBSCommissionApi, CBSCommonApi } from "@/services/api";

export default {
  name: "CommissionPlanForm",
  components: {},
  computed: {
    ...mapGetters(["profile"]),
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {},
    allApplications: [],
    pre: {},
  }),
  methods: {
    handleSubmission() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.is_loading = true;
          if (this.is_edit) {
            this.value.updated_by = this.profile.id;
            CBSCommissionApi.updateCommissionPlan(this.params.id, this.value)
              .then((response) => {
                if (response.code == 200) {
                  this.$router.push({ name: "CommissionPlanList" });
                  this.$toaster.success(response.message);
                } else {
                  this.$toaster.error(response.message);
                }
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.response.data);
              })
              .finally(() => {
                this.is_loading = false;
              });
          } else {
            this.value.organization_ref_id = this.profile.organization_ref_id;
            this.value.user_ref_id = this.profile.user_ref_id;
            this.value.role_ref_id = this.profile.role_ref_id;
            this.value.created_by = this.profile.id;
            CBSCommissionApi.storeCommissionPlan(this.value)
              .then((response) => {
                if (response.code == 200) {
                  this.$toaster.success(response.message);
                  this.$router.push({ name: "CommissionPlanList" });
                } else {
                  this.$toaster.error(response.message);
                }
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.response.data);
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        }
      });
    },
    getDetail: function (id) {
      CBSCommissionApi.showCommissionPlan(id)
        .then((item) => {
          this.value = item;
        })
        .catch((error) => {
          this.$toaster.error(error.response.data.message);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getApplications: function () {
      CBSCommonApi.getAllApplications().then((response) => {
        this.allApplications = response;
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id);
      }
      await this.getApplications();
      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
